/**
 * The SoundTransform class contains properties for volume and panning.
 *
 */
var SoundTransform = (function () {
    /**
     * Creates a SoundTransform object.
     * @param	vol	The volume, ranging from 0 (silent) to 1 (full volume).
     * @param	panning	The left-to-right panning of the sound, ranging from -1 (full pan left)
     *   to 1 (full pan right). A value of 0 represents no panning (center).
     * @langversion	3.0
     * @playerversion	Flash 9
     * @playerversion	Lite 4
     * @refpath
     */
    function SoundTransform(vol, panning) {
        if (vol === void 0) { vol = 1; }
        if (panning === void 0) { panning = 0; }
        this._vol = 1;
        this._pan = 0.5;
    }
    // for AVM1:
    SoundTransform.prototype.axCallPublicProperty = function (value1, value2) {
        return null;
    };
    SoundTransform.prototype.axGetPublicProperty = function (value) {
        return null;
    };
    SoundTransform.prototype.axSetPublicProperty = function (value, value2) {
        return null;
    };
    SoundTransform.prototype.axHasPublicProperty = function (value) {
        return null;
    };
    SoundTransform.prototype.axDeletePublicProperty = function (value) {
        return null;
    };
    SoundTransform.prototype.axGetEnumerableKeys = function () {
        return [];
    };
    Object.defineProperty(SoundTransform.prototype, "leftToLeft", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the left input is played in the
         * left speaker.
         */
        get: function () {
            console.log("leftToLeft not implemented yet in flash/SoundTransform");
            return 0;
        },
        set: function (leftToLeft) {
            console.log("leftToLeft not implemented yet in flash/SoundTransform");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "leftToRight", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the left input is played in the
         * right speaker.
         */
        get: function () {
            console.log("leftToRight not implemented yet in flash/SoundTransform");
            return 0;
        },
        set: function (leftToRight) {
            console.log("leftToRight not implemented yet in flash/SoundTransform");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "pan", {
        /**
         * The left-to-right panning of the sound, ranging from -1 (full pan left)
         * to 1 (full pan right). A value of 0 represents no panning (balanced center between
         * right and left).
         */
        get: function () {
            return this._pan;
        },
        set: function (value) {
            this._pan = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "rightToLeft", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the right input is played in the
         * left speaker.
         */
        get: function () {
            console.log("rightToLeft not implemented yet in flash/SoundTransform");
            return 0;
        },
        set: function (rightToLeft) {
            console.log("rightToLeft not implemented yet in flash/SoundTransform");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "rightToRight", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the right input is played in the
         * right speaker.
         */
        get: function () {
            console.log("rightToRight not implemented yet in flash/SoundTransform");
            return 0;
        },
        set: function (rightToRight) {
            console.log("rightToRight not implemented yet in flash/SoundTransform");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "volume", {
        /**
         * The volume, ranging from 0 (silent) to 1 (full volume).
         */
        get: function () {
            return this._vol;
        },
        set: function (value) {
            this._vol = value;
        },
        enumerable: true,
        configurable: true
    });
    return SoundTransform;
}());
export { SoundTransform };
